import makeTypeCreator from '@/models/makeTypeCreator'

const namespace = 'user'
const createType = makeTypeCreator(namespace)

export const GET_CURRENT_USER = createType('GET_CURRENT_USER')
export const SAVE_CURRENT_USER = createType('SAVE_CURRENT_USER')
export const LOGOUT = createType('LOGOUT')
